










import { Component, Prop, Vue } from 'vue-property-decorator';
import KBStatus from '@/models/KnowledgeBase/KBStatus';
import { STATUS_COLORS } from '@/lib/kbConstants';

@Component({
  name: 'KBStatusBadge'
})
export default class KBStatusBadge extends Vue {
  @Prop({ required: true })
  public status!: string;

  public get statusColor(): string {
    return STATUS_COLORS[this.status] || 'grey';
  }

  public get statusText(): string {
    switch (this.status) {
      case KBStatus.Draft:
        return 'Draft';
      case KBStatus.Published:
        return 'Published';
      case KBStatus.Archived:
        return 'Archived';
      default:
        return this.status;
    }
  }
}
